import { useCallback, useEffect, useState } from 'react';
import { sdk } from 'src/utilities/sdk';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import { IParentCorpResponse } from 'src/types/Corp';

export type UseGetParentCorpDataReturn = {
  data?: IParentCorpResponse;
  isLoading?: boolean;
  refetch: () => void;
};

export const useGetParentCorpData = (
  corpId: string
): UseGetParentCorpDataReturn => {
  const [isLoading, setIsLoading] = useState<boolean>();
  const [data, setData] = useState<IParentCorpResponse>();

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      const responseData = await sdk.http.get(
        `/corp-admin/parent-corp/${corpId}`
      );

      setData(responseData);
    } catch (error) {
      pushErrorFromAPI(error);
    } finally {
      setIsLoading(false);
    }
  }, [corpId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    isLoading,
    refetch: fetchData,
  };
};
